module.exports = __webpack_public_path__ + "static/media/meio_pasta_preta.94294207.png";